import { useState } from 'react';
import defaultImg from '../assets/images/egg/empty.png';
import { useEffect } from 'react';

// egg 폴더 내 모든 .png 파일을 불러오기
const imagesContext = require.context(
  '../assets/images/egg', // 상대경로로 바꿔야 CRA에서 인식됨
  false,
  /\.png$/,
);

// 이미지 이름을 키로, 이미지 경로를 값으로 한 객체 생성
const imageMap = imagesContext.keys().reduce((map, path) => {
  const fileName = path.replace('./', ''); // './egg1.png' → 'egg1.png'
  map[fileName] = imagesContext(path);
  return map;
}, {});

const BASE_IMG_URL = `../assets/images/egg`;

const EggImageMain = ({ eggId, onClick }) => {
  const [imgSrc, setImgSrc] = useState(`${BASE_IMG_URL}/${eggId}.png`);

  const handleError = () => {
    setImgSrc('../assets/images/new_main/blank-main-cat.png'); // 기본 이미지로 대체
  };

  useEffect(() => {
    // 'egg1' 같은 이름이 들어오면 'egg1.png' 로 확장자 붙이기
    const fileName = `${eggId}.png`;

    if (imageMap[fileName]) {
      setImgSrc(imageMap[fileName]);
    } else {
      setImgSrc(defaultImg);
    }
  }, [eggId]);

  return <img onClick={onClick} src={imgSrc} onError={handleError} alt='cat-background' width={64.79} height={82.8} />;
};

export default EggImageMain;
